import { useSelector } from "react-redux";
import { useState, Fragment } from "react";
import { CgProfile } from "react-icons/cg";
import { IconButton, Menu } from "@mui/material";

import DropDownMenu from "./drop down menu components/DropDownMenu";

export default function DropDownButton() {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const { role } = useSelector((state) => state.memberDetails);

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          setMenuAnchor(event.currentTarget);
        }}
      >
        <CgProfile
          style={{
            height: "30px",
            width: "30px",
            color: "#FFF",
            cursor: "pointer",
            display: "flex",
            alignSelf: "center",
          }}
        />
      </IconButton>

      <Menu
        style={{ marginTop: "15px" }}
        open={Boolean(menuAnchor)}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <DropDownMenu role={role} setMenuAnchor={setMenuAnchor} />
      </Menu>
    </Fragment>
  );
}
